import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorDialogService {
  private opened = false;

  constructor(private dialog: MatDialog, private translateService: TranslateService) {}

  openDialog(message: string, isError: boolean = true, value = ''): void {
    if (!this.opened && message) {
      this.opened = true;
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        data: { message: this.translateService.instant(message, { value: value }), isError },
        maxWidth: '700px',
      });
      dialogRef.afterClosed().subscribe(() => {
        this.opened = false;
      });
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
